import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoBlockData, InfoBlockComponent } from './info-block.component';
import { ImageBlockData } from './image-block.component';
import { SERVER_BASE_URL } from '../environment.token';
import { RouterModule } from '@angular/router';
import { LanguagePrefixPipe } from '../pipes/language-prefix.pipe';

@Component({
  selector: 'ca-detail-block-list',
  imports: [CommonModule, RouterModule, LanguagePrefixPipe],
  template: `
  <div class="detail-block-list">
  <div class="detail-block-list-items">
    @if (data) {
      @for (block of data.content; track block) {
        @if (block.content && block.content.image && block.content.image.src){

          <a [routerLink]="block && block.content && block.content.cta && block.content.cta.type === 'intern' ? (block.content.cta.routerLink | languagePrefix | async) : null"
  [attr.href]="block && block.content && block.content.cta && block.content.cta.type === 'extern' ? block.content.cta.href : null">
          <figure>
            <img [src]="base + block.content.image.src" [alt]="block.content.image.alt">
                  <figcaption><span>{{block.content.title}}</span></figcaption>
          </figure>
          </a>
        }
      }
    }
  </div>
  </div>
  `,
  styles: ``,
})
export class DetailBlockListComponent {
  @Input() data?: DetailBlockListData;
  readonly base = inject(SERVER_BASE_URL);
}

export interface DetailBlockListData {
  cssClass: null | string;
  content: (InfoBlockData & { image: ImageBlockData })[];
}
